import { useCallback } from 'react';
import { useAuthStore } from './useAuthStore';
import { buildLoginUrl, refreshTokens } from './cognito';

export function useAuth() {
  const { idToken, accessToken, expiresAt, refreshToken, user, setTokens, setUser, clear } = useAuthStore();

  const isAuthenticated = !!idToken && !!expiresAt && expiresAt > Date.now();

  const login = useCallback(() => {
    window.location.href = buildLoginUrl();
  }, []);

  // Route through LogoutPage — it clears memory + storage then hits Cognito,
  // so localStorage is always wiped before any redirect happens.
  const logout = useCallback(() => {
    window.location.href = '/logout';
  }, []);

  // Returns true if a valid token is available after the call (refreshes if needed).
  const ensureFreshToken = useCallback(async (): Promise<boolean> => {
    if (idToken && expiresAt && expiresAt - Date.now() > 5 * 60 * 1000) return true;
    if (!refreshToken) return false;
    try {
      const tokens = await refreshTokens(refreshToken);
      setTokens({ idToken: tokens.id_token, accessToken: tokens.access_token, expiresIn: tokens.expires_in });
      return true;
    } catch {
      clear();
      return false;
    }
  }, [idToken, expiresAt, refreshToken, setTokens, clear]);

  return { isAuthenticated, user, idToken, accessToken, login, logout, ensureFreshToken, setUser, clear };
}
